import {Mutation} from "../ApiProvider/types";
import {makeMutation} from "../hooks";

export interface CallLogs {
    id: number;
}

export interface CallLogsCreateInput {
    callerName: string;
    callerPhone: string;
    callerAddress: string;
    callerCity: string;
    callerState: string;
    callerZip: string;
    callerText: string;
    calledAt: string;
    actionsTaken: string;
}

const createCallLogsMutation: Mutation<CallLogs> = {
    path: "/api/call_logs",
    xFields: ["id"],
    type: "POST",
}


const updateCallLogsMutation: Mutation<CallLogs> = {
    path: "/api/call_logs/<id>",
    xFields: ["id"],
    type: "PUT",
}

const deleteCallLogsMutation: Mutation<{}> = {
    path: "/api/call_logs/<id>",
    xFields: [],
    type: "DELETE",
}


export const useCreateCallLogs = makeMutation<CallLogsCreateInput, CallLogs>(createCallLogsMutation);
export const useUpdateCallLogs = makeMutation<CallLogsCreateInput, CallLogs>(updateCallLogsMutation);
export const useDeleteCallLogs = makeMutation(deleteCallLogsMutation);